<template>
  <header class="text-center sm:text-left" data-testid="app-header">
    <h1 class="font-display text-3xl font-semibold text-neutral-900 sm:text-5xl">
      {{ t('common.app-name') }}
    </h1>
  </header>
</template>

<script setup>
import { useText } from '../composables/useText.js';

const { t } = useText();
</script>
